module.exports = __webpack_public_path__ + "static/media/tokenomics-left.394cd0ba.png";